import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { steps } from './wizard-n35encuestador.steps';
import { stepsV3 } from './wizard-n35encuestador.steps';
///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as backInter from 'app/auth/auth-data.model';
import {AuthService} from 'app/auth/auth.service';
import { WizardN35EncuestadorService } from './services/wizardn35encuestador.services';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import {TranslateService} from '@ngx-translate/core';
import *  as $ from 'jquery';
import { ActivatedRoute } from '@angular/router';
import { DATOS_API } from 'app/auth/auth.datos';
@Component({
  selector: 'app-wizard-n35encuestador',
  templateUrl: './wizard-n35encuestador.component.html',
  styleUrls: ['./wizard-n35encuestador.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class WizardN35encuestadorComponent implements OnInit {
  animationDirection: 'left' | 'right' | 'none';
  course: any;
  steps: any;
  currentStep: number;
  lastStep: number;
  /// datos de los steps
  idiomas: any;
  iconoStep: any = {
    'undone': 'lock',
    'pending': 'more_horiz',
    'done': 'done'
  };
  // Datos certificar vigente
  productoCertificar: backInter.prodNorma35;
  // objeto statuses
  statusSteps: backInter.getAllStatus;
  //booleans de los steps
  idiomaVideo:string;
  stp1Ok = false;
  stpAllOk = false;
  idiomaActual:string;
  // message:string;
  //mensaje enviado desde components hijos al component wizard CGO
  mensajeEntreComponents: string;
  statusSteps_Tmp;
  info:any;
  pasosWizard:any;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseSidebarService: FuseSidebarService,
    private dialog: MatDialog,
    public authService: AuthService,
    private translateSrv: TranslateService,
    private wizardService: WizardN35EncuestadorService,
    private activatedRoute:ActivatedRoute,

  ) {
    this.animationDirection = 'none';
    this.currentStep = 0;
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    // orden de actualizacion de botones del wizard
    // *** Consultar
    this.wizardService.mensajeActual.subscribe( (resu) => {
      console.log("Entro wizard");
      this.mensajeEntreComponents = resu;
      switch(this.mensajeEntreComponents){
        case "100": this.getTodosLosStatus(); break;
      }
    });



    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; this.cambiaIdiomaVideo(this.idiomaActual,this.currentStep); });

  }

  ngOnInit(): void{
    // console.log(window.location.origin);
    this.activatedRoute.data.subscribe(params => {
      console.log(params.producto);
      switch(params.producto){
        case "Nom1":
        this.steps = steps;
        this.pasosWizard = steps;
        break;
        case "Nom3":
        this.steps = stepsV3;
        this.pasosWizard = stepsV3;
        break;
      }

    });

    this.course = {
        'id'         : '15459251a6d6b397565',
        'title'      : 'Encuestador',
        'slug'       : 'norm035-encuesta',
        'description': 'Commits that need to be pushed lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        'category'   : 'CGO',
        'length'     : 30,
        'totalSteps' : 4,
        'updated'    : '9 Agosto 2019',
        'steps'      : this.steps,
        'tagTrad': 'WIZARD.CERTIFICAR.TITULO'
    };
    //this.actualizaStatusStepWizard();
    this.obtieneCertActual();
    /*this.limpiaVariables();
    this.obtieneCertActual();*/
    this.idiomaActual = this.translateSrv.currentLang;
    this.cambiaIdiomaVideo(this.idiomaActual,this.currentStep);
  }

  // cambiaIdiomaVideo(idioma:string, step:number){
  //   this.idiomaVideo = this.translateSrv.currentLang;
  //   switch(idioma){
  //     case 'es': this.idiomaVideo = idioma; break;
  //     default: this.idiomaVideo = 'en';
  //   }
  //   this.getBanner(step);
  // }
  cambiaIdiomaVideo(idioma:string, step:number){
    this.idiomaVideo = this.translateSrv.currentLang;
    setTimeout( () => {
      // let url = './assets/video/wizard/certificar/banner/' + this.idiomaVideo + '/' + this.pasosWizard[step].videoBanner + '.mp4';
      console.log(this.pasosWizard);
      console.log(step);
      let url = DATOS_API.urlAssets + 'video/wizard/certificar/banner/' + this.idiomaVideo + '/' + this.pasosWizard[step].videoBanner + '.mp4';
      console.log("URL");
      console.log(url);
      $("#videoBanner"+step).attr("src",url);
    },200);
  }



  getBanner(numStep){

    switch(numStep){
      case 0:
        setTimeout( () => {
          let url = 'assets/images/norm35/certificar/banner/' + this.idiomaVideo + '/' + 'colaboradores' + '.mp4';
          $("#videoBanner"+numStep).attr("src",url);
        },200);
      break;
      case 1:
        setTimeout( () => {
          let url = 'assets/images/norm35/certificar/banner/' + this.idiomaVideo + '/' + 'programar' + '.mp4';
          $("#videoBanner"+numStep).attr("src",url);
        },200);
      break;
      case 2:
          /*setTimeout( () => {
            let url = 'assets/images/norm35/certificar/banner/' + this.idiomaVideo + '/' + 'colaboradores' + '.mp4';
            $("#videoBanner"+numStep).attr("src",url);
          },200);*/
      break;
      case 3:
        setTimeout( () => {
          let url = 'assets/images/norm35/certificar/banner/' + this.idiomaVideo + '/' + 'cierre' + '.mp4';
          $("#videoBanner"+numStep).attr("src",url);
        },200);
      break;

    }
  }


  /*limpiaVariables(){
    this.productoCertificar = null;
    this.statusSteps = null;
  }*/

  obtieneCertActual(){
    /// obtiene el producto certificar vigente
    console.log("Dude certificar");
    this.wizardService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
                this.getTodosLosStatus();
              throw BreakException;
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getTodosLosStatus(){

    let productoId=this.productoCertificar.idNorma35;
    this.wizardService.getStatus(productoId).subscribe( (data: backInter.getAllStatus) => {
      console.log('Data',data);

      this.statusSteps = data;
      this.statusSteps_Tmp=this.statusSteps.estatusSecciones;
      console.log("Estaciones");
      console.log();

      if (localStorage.getItem('tipoNorma35')=='v3') {
        console.log('entro para producto v3');

        this.actualizaStatusStepWizardV3();
        this.configuraStepsV3();

      }else{
        this.actualizaStatusStepWizard();
        this.configuraSteps();
      }

    });
  }

  configuraSteps(){
    //IDS de los steps
    let statusActualizar = ["colaboradores","colaboradores35","programacion","envio","close"];
    let colb = this.statusSteps.estatusSecciones.colaboradores;
    let colb35 = this.statusSteps.estatusSecciones.colaboradores;
    let prog = this.statusSteps.estatusSecciones.programacion;
    let envi = this.statusSteps.estatusSecciones.envio;
    let cier = this.statusSteps.estatusSecciones.close;
    let statusVars =[colb,colb35,prog,envi,cier];

      if(colb == 1){
        this.actualizaPaso(statusActualizar[0],2);
      }
      //fora == 3 && demo == 3 && adic == 3 &&
      if( colb == 3){
        if(prog == 1){
          this.actualizaPaso(statusActualizar[2],2);
        }
        if(prog == 3 && envi == 1){
          this.actualizaPaso(statusActualizar[3],2);
        }
        if(prog == 3 && envi == 3 && cier == 1){
          this.actualizaPaso(statusActualizar[4],2);
        }
      }/*else{
       let iter = 0;
       statusActualizar.forEach( (clave) => {
         if(statusVars[iter] != 1)
           this.actualizaPaso(clave,1);
         iter++;
       });
    }*/
  }

  configuraStepsV3(){
    //IDS de los steps
    let statusActualizar = ["colaboradores","colaboradores35","programacion","envio","close","encuesta","confirmacion"];
    let colb = this.statusSteps.estatusSecciones.colaboradores;
    let colb35 = this.statusSteps.estatusSecciones.colaboradores;
    let encu = this.statusSteps.estatusSecciones.encuesta;
    let prog = this.statusSteps.estatusSecciones.programacion;
    let envi = this.statusSteps.estatusSecciones.envio;
    let confir = this.statusSteps.estatusSecciones.confirmacion;
    let cier = this.statusSteps.estatusSecciones.close;
    let statusVars =[colb,colb35,prog,envi,cier,encu];
console.log('confir',confir);

      if(colb == 1){
        this.actualizaPaso('colaboradores',2);
      }

       if( colb == 3){
        if (prog== 1) {
          this.actualizaPaso('programacion',2);
        }else if (prog==3) {
          if(encu == 1){
              this.actualizaPaso('encuesta',2);
          }else if(encu == 3){
            if (envi==1) {
              this.actualizaPaso('envio',2)
            }else if(envi==3){
              if (confir==1) {
                this.actualizaPaso('confirmacion',2)
              }else if (confir==3) {
                if (cier==1) {
                  this.actualizaPaso('close',2);
                }
              }else{
                cier!=1 ?this.actualizaPaso('close',1) : false;

              }
            }else{
              console.log('si entro este Caso ');
              confir!=1 ? this.actualizaPaso('confirmacion',1) : false;
              cier!=1 ?this.actualizaPaso('close',1) : false;
            }
          }else{
            envi!=1 ? this.actualizaPaso('envio',1) : false;
            confir!=1 ? this.actualizaPaso('confirmacion',1) : false;
            cier!=1 ?this.actualizaPaso('close',1) : false;
          }
        }else{
          encu!=1 ? this.actualizaPaso('encuesta',1) : false;
          envi!=1 ? this.actualizaPaso('envio',1) : false;
          confir!=1 ? this.actualizaPaso('confirmacion',1) : false;
          cier!=1 ?this.actualizaPaso('close',1) : false;
        }
      }else{
        prog!=1 ? this.actualizaPaso('programacion',1) : false ;
        encu!=1 ? this.actualizaPaso('encuesta',1) : false;
        envi!=1 ? this.actualizaPaso('envio',1) : false;
        cier!=1 ? this.actualizaPaso('close',1) : false;
      }
  }

  actualizaPaso(paso:string, status:number){

    let datos: any;
    let anioCert = this.productoCertificar.fechaNorma35;
    let idproducto = this.productoCertificar.idNorma35;
    switch(paso){
      case 'colaboradores': datos = {productoId: idproducto,	colaboradores: status}; break;
      case 'encuesta': datos = {productoId: idproducto,	encuesta: status}; break;
      case 'programacion': datos = {productoId: idproducto,	programacion: status}; break;
      case 'confirmacion': datos = {productoId: idproducto,	confirmacion: status}; break;
      case 'envio': datos = {productoId: idproducto,	envio: status}; break;
      case 'close': datos = {productoId: idproducto,	close: status}; break;
    };

    this.wizardService.saveStatus(datos).subscribe( (data: backInter.RespuestaGen) => {

      let codigosSuccess = ['210','211','212','213','214','215','216','217','218', '220','222','221'];
      if(codigosSuccess.includes(data.message)){
        this.getTodosLosStatus();
      }
    });
    /*this.wizardService.guardaStatusStep(datos).subscribe( (data: backInter.RespuestaGen) => {
      console.log(data);
      let codigosSuccess = ['210','211','212','213','214','215','216','217'];
      if(codigosSuccess.includes(data.message)){
        this.getTodosLosStatus();
      }
    });*/
  }

  actualizaStatusStepWizard(){
    //estados de pasos: 1=bloqueado, 2=desbloqueado 3=terminado

    let statusEnc=this.statusSteps_Tmp.colaboradores ;
    let statusColabs =this.statusSteps_Tmp.colaboradores;
    let statusProg =this.statusSteps_Tmp.programacion;
    let statusMailSe =this.statusSteps_Tmp.envio;
    let statusClose =this.statusSteps_Tmp.close;
    let statusEncu = this.statusSteps_Tmp.encuesta;
    this.steps.forEach( (step) => {
      switch(step.id){
        case 'colabs35': step.status = statusColabs; break;
        case 'colabs': step.status = statusColabs; break;
        case 'encuesta': step.status = statusEncu; break;
        case 'prog': step.status = statusProg; break;
        case 'envio': step.status = statusMailSe; break;
        case 'cierre': step.status = statusClose; break;
      }
    });
    console.log("PASOS");
    //console.log(this.steps);
    this.stpAllOk = true;
  }

  actualizaStatusStepWizardV3(){
    //estados de pasos: 1=bloqueado, 2=desbloqueado 3=terminado

    let statusEnc=this.statusSteps_Tmp.colaboradores ;
    let statusColabs =this.statusSteps_Tmp.colaboradores;
    let statusProg =this.statusSteps_Tmp.programacion;
    let statusMailSe =this.statusSteps_Tmp.envio;
    let statusClose =this.statusSteps_Tmp.close;
    let statusEncu = this.statusSteps_Tmp.encuesta;
    let statusConfirm = this.statusSteps_Tmp.confirmacion;
    this.steps.forEach( (step) => {
      switch(step.id){
        case 'colabs35': step.status = statusColabs; break;
        case 'colabs': step.status = statusColabs; break;
        case 'encuesta': step.status = statusEncu; break;
        case 'programacion': step.status = statusProg; break;
        case 'confirmacion': step.status = statusConfirm; break;
        case 'envio': step.status = statusMailSe; break;
        case 'cierre': step.status = statusClose; break;
      }
    });
    console.log("PASOS");
    //console.log(this.steps);
    this.stpAllOk = true;
  }

  gotoStep(step): void{
    this.animationDirection = this.currentStep < step ? 'left' : 'right';
    this.lastStep = this.currentStep;
    this.currentStep = step;
    //console.log("Paso a donde ir "+this.currentStep);
    this.idiomaActual = this.translateSrv.currentLang;
    this.cambiaIdiomaVideo(this.idiomaActual,step);
  }

  gotoNextStep(): void{
      if ( this.currentStep === this.course.totalSteps - 1 )
      {
        return;
      }
      this.animationDirection = 'left';
      //this._changeDetectorRef.detectChanges();
      this.currentStep++;
  }

  gotoPreviousStep(): void{
      if ( this.currentStep === 0 )
      {
          return;
      }
      this.animationDirection = 'right';
      //this._changeDetectorRef.detectChanges();
      this.currentStep--;
  }

  toggleSidebar(name): void{
      this._fuseSidebarService.getSidebar(name).toggleOpen();
  }

  aletaRestric(opc:number){
      /*let infoModal: adverModal = {'tipo': 3, 'mensaje': '', 'diccionario': 'WIZARD.CERTIFICAR.'};
      let infoGen: any;
      switch(opc){
        case 1: case 2: case 3: case 4: infoModal.mensaje = 'RESTRICCIONES.rest1'; break;
        case 5:  infoModal.mensaje = 'RESTRICCIONES.rest2'; break;
        case 6: infoModal.mensaje = 'RESTRICCIONES.rest3'; break;
        case 7: infoModal.mensaje = 'RESTRICCIONES.rest4'; break;
        default: infoGen = {'message': 'mensajeGenerico'};
      }
      if(opc < 8)
        this.dialog.open(ModalComponent, { data:infoModal });
      else
        this.dialog.open(ModalComponent, { data:infoGen }); */
  }

  pruebaservicio(){
    this.wizardService.getStatus(this.productoCertificar.fechaNorma35).subscribe( (data) => {
      console.log("Prueba servicio");
      console.log(data);
    });
  }

}
